"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridConfigurationStore = void 0;
const application_logger_1 = require("../application-logger");
class HybridConfigurationStore {
    constructor(servingStore, persistentStore) {
        this.servingStore = servingStore;
        this.persistentStore = persistentStore;
    }
    /**
     * Initialize the configuration store by loading the entries from the persistent store into the serving store.
     */
    async init() {
        if (!this.persistentStore) {
            return;
        }
        if (!this.persistentStore.isInitialized()) {
            /**
             * The initial remote request to the remote API failed
             * or never happened because we are in the cool down period.
             *
             * Shows a log message that the assignments served from the serving store
             * may be stale.
             */
            application_logger_1.logger.warn(`${application_logger_1.loggerPrefix} Persistent store is not initialized from remote configuration. Serving assignments that may be stale.`);
        }
        const entries = await this.persistentStore.getEntries();
        this.servingStore.setEntries(entries);
    }
    isInitialized() {
        var _a, _b;
        return this.servingStore.isInitialized() && ((_b = (_a = this.persistentStore) === null || _a === void 0 ? void 0 : _a.isInitialized()) !== null && _b !== void 0 ? _b : true);
    }
    async isExpired() {
        var _a;
        const isExpired = await ((_a = this.persistentStore) === null || _a === void 0 ? void 0 : _a.isExpired());
        return isExpired !== null && isExpired !== void 0 ? isExpired : true;
    }
    get(key) {
        if (!this.servingStore.isInitialized()) {
            application_logger_1.logger.warn(`${application_logger_1.loggerPrefix} getting a value from a ServingStore that is not initialized.`);
        }
        return this.servingStore.get(key);
    }
    getKeys() {
        return this.servingStore.getKeys();
    }
    async setEntries(entries) {
        if (this.persistentStore) {
            // Persistence store is now initialized and should mark itself accordingly.
            await this.persistentStore.setEntries(entries);
        }
        this.servingStore.setEntries(entries);
    }
}
exports.HybridConfigurationStore = HybridConfigurationStore;
//# sourceMappingURL=hybrid.store.js.map